import { useState } from "react";

export function useUniqueId(): string {
  return useState(Math.random().toString(36).substring(2, 7))[0];
}
